import { client } from "../request";

/**
 * 現場のプロパティキー
 */
export interface ProjectPropertyKey {
  id: string;
  name: string;
  deletedAt: string | null;
}

/**
 * 現場のプロパティキーの一覧を取得する
 */
export async function getProjectPropertyKeys(): Promise<ProjectPropertyKey[]> {
  return await client.get("get_all_project_property_keys.php");
}

export interface SaveProjectPropertyKeyCommand {
  id?: string;
  name: string;
}

/**
 * 現場のプロパティキーを保存する
 */
export async function saveProjectPropertyKey(
  command: SaveProjectPropertyKeyCommand
) {
  const data = new FormData();
  if (command.id) {
    data.append("id", command.id);
  }
  data.append("name", command.name);
  await client.post("create_project_property_key.php", data);
}

/**
 * 現場のプロパティキーを削除する
 */
export async function deleteProjectPropertyKey(id: string): Promise<void> {
  const data = new FormData();
  data.append("id", id);
  await client.post("delete_project_property_key.php", data);
}

/**
 * 現場のプロパティキーを取得する
 */
export async function getProjectPropertyKey(
  id: string
): Promise<ProjectPropertyKey | null> {
  return await client.get("get_project_property_key.php", { id });
}
